import { render, staticRenderFns } from "./CanvasRender.vue?vue&type=template&id=36d1c702&"
import script from "./CanvasRender.vue?vue&type=script&lang=js&"
export * from "./CanvasRender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports